import { useParams } from 'react-router-dom'
import { IParamID } from 'types/storeTypes'

const useRouteParamNameWIthId = () => {
    const { id } = useParams<IParamID>()
    return id
}

export default useRouteParamNameWIthId
